import type { MouseEventHandler } from 'react';
import globalStyles from './global.module.css';
import CloudDownloadIcon from './img/cloud-download-svgrepo-com.svg';

interface LoadScheduleButtonProps {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
}

function LoadScheduleButton({ onClick, disabled = false }: LoadScheduleButtonProps) {
    return (
        <button
            className={globalStyles.labeledButton}
            onClick={onClick}
            disabled={disabled}
            title="Gespeicherte Stundenpläne dieses Kurses öffnen"
        >
            <img
                src={CloudDownloadIcon}
                alt=""
                aria-hidden="true"
                className={globalStyles.labeledButtonIcon}
            />
            <span>Gespeicherte Pläne</span>
        </button>
    );
}

export default LoadScheduleButton;
